import { render } from "./FooterText.vue?vue&type=template&id=29f50df0"
import script from "./FooterText.vue?vue&type=script&lang=js"
export * from "./FooterText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__